module.exports = __webpack_public_path__ + "static/media/Image3.abfbd34c.svg";